<template>
  <el-dialog
    title="添加银行卡"
    :visible.sync="visible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
    width="40%"
  >
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleFormRef"
        label-width="130px"
        :size="formSize"
      >
        <el-form-item label="服务商名称:">
          <el-input
            v-model.trim="ruleForm.businessName"
            placeholder="请输入"
            style="width: 100%;"
            disabled
          />
        </el-form-item>
        <el-form-item label="账户类型:" prop="accountType">
          <jr-select
            v-model="ruleForm.accountType"
            :size="formSize"
            :hasAll="false"
            placeholder="请选择"
            dictionary-type="BANK_CARD_TYPE"
            select-style="width: 100%;"
            @change="accountTypeChange"
          />
        </el-form-item>
        <template v-if="isBankRequired">
          <el-form-item
            label="银行户名:"
            prop="bankAccName"
            :rules="[{ required: isBankRequired, message: '请输入', trigger: 'blur' }]"
          >
            <el-input
              v-model.trim="ruleForm.bankAccName"
              placeholder="请输入"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item
            label="银行账号:"
            prop="bankAccount"
            :rules="[{ required: isBankRequired, message: '请输入', trigger: 'blur' }]"
          >
            <el-input
              v-model.trim="ruleForm.bankAccount"
              placeholder="请输入"
              oninput="value=value.replace(/[^\d]/g,'')"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item
            label="银行名称:"
            prop="bankName"
            :rules="[{ required: isBankRequired, message: '请选择', trigger: 'blur' }]"
          >
            <el-select
              v-model="ruleForm.bankName"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请选择银行名称"
              :remote-method="_getBankList"
              :loading="loading"
              style="width: 100%;"
            >
              <el-option
                v-for="item in backOptions"
                :key="item.bankName"
                :label="item.bankName"
                :value="item.bankName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="支行名称:"
            prop="branchName"
            :rules="[{ required: isBankRequired, message: '请选择', trigger: 'blur' }]"
          >
            <el-select
              v-model="ruleForm.branchName"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入"
              :remote-method="_getBranchList"
              :loading="branchloading"
              style="width: 100%;"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchCode"
                :label="item.branchName"
                :value="item.branchName"
              />
            </el-select>
          </el-form-item>
        </template>
        <template v-if="isAccountRequired">
          <el-form-item
            label="账户名称:"
            prop="accName"
            :rules="[{ required: isAccountRequired, message: '请输入', trigger: 'blur' }]"
          >
            <el-input
              v-model.trim="ruleForm.accName"
              placeholder="请输入"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item
            label="账户编号:"
            prop="accNo"
            :rules="[{ required: isAccountRequired, message: '请输入', trigger: 'blur' }]"
          >
            <el-input
              v-model.trim="ruleForm.accNo"
              placeholder="请输入"
              style="width: 100%;"
            />
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="handleClose" :size="formSize">取 消</el-button>
      <el-button type="primary" @click="submitForm" :size="formSize" :loading="submitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addServiceBankcard } from '@/api/servicer';
import { getBankList, getBankBranchList } from '@/api/global';

export default {
  name: 'AddBankComponents',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    businessName: {
      type: String,
      default: '',
    },
    customerNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      branchloading: false,
      backOptions: [],
      branchList: [],
      ruleForm: {
        customerNo: '', // 财务客户编号
        businessName: '', // 客户名称
        accountType: '',
        bankAccName: '',
        bankAccount: '',
        bankName: '',
        branchName: '',
        accName: '',
        accNo: '',
      },
      rules: {
        accountType: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      submitLoading: false,
    };
  },
  computed: {
    isBankRequired() {
      return [1, 2].includes(this.ruleForm.accountType);
    },
    isAccountRequired() {
      return [3, 4].includes(this.ruleForm.accountType);
    },
  },
  methods: {
    // 关闭窗口前
    handleClose() {
      this.$emit('update:visible', false);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.ruleFormRef.resetFields();
        this.backOptions = [];
        this.branchList = [];
        this.ruleForm = {
          customerNo: this.customerNo, // 财务客户编号
          businessName: this.businessName, // 名称
          accountType: '',
          bankAccName: '',
          bankAccount: '',
          bankName: '',
          branchName: '',
          accName: '',
          accNo: '',
        };
      });
    },
    _getBankList(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          getBankList({
            page: 1,
            limit: 200,
            bankNameLike: query,
          }).then((res) => {
            this.backOptions = res?.data || [];
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      } else {
        this.loading = false;
        this.backOptions = [];
      }
    },
    // 获取支行信息
    _getBranchList(query) {
      const { bankName } = this.ruleForm;
      if (query !== '' && bankName) {
        this.branchloading = true;
        setTimeout(() => {
          getBankBranchList({
            page: 1,
            size: 200,
            bankName,
            branchLike: query,
          }, true).then((res) => {
            this.branchList = res?.data || [];
            this.branchloading = false;
          });
        }, 200);
      } else {
        if (!bankName) {
          this.$message.warning('请先输入银行名称！');
        }
        this.branchloading = false;
        this.branchList = [];
      }
    },
    accountTypeChange() {
      this.ruleForm = {
        ...this.ruleForm,
        bankAccName: '',
        bankAccount: '',
        bankName: '',
        branchName: '',
        accName: '',
        accNo: '',
      };
    },
    submitForm() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.handleSubmit();
        }
      });
    },
    // 确认添加
    async handleSubmit() {
      try {
        this.submitLoading = true;
        await addServiceBankcard(this.ruleForm);
        this.$message.success('添加成功');
        this.submitLoading = false;
        this.handleClose();
        this.$emit('success');
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },

  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .content {
    margin: 0;
  }
}
</style>
